var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CSV_File",
    "data-name": "CSV File",
    transform: "translate(10756 3822)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 42,
    height: 42,
    transform: "translate(-10756 -3822)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "csv",
    transform: "translate(-10754.5 -3818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    d: "M25.009,0H7.388C6.9,0,6.5.4,6.5,1.169V33.393A.914.914,0,0,0,7.388,34H31.719a.914.914,0,0,0,.888-.607V7.879c0-.423-.056-.559-.156-.659L25.386.156A.537.537,0,0,0,25.009,0Z",
    transform: "translate(0 0)",
    fill: "#e9e9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M37.5.151V7.345h7.194Z",
    transform: "translate(-12.179 -0.059)",
    fill: "#d9d7ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M31.719,49.321H7.388a.888.888,0,0,1-.888-.888V39H32.607v9.433A.888.888,0,0,1,31.719,49.321Z",
    transform: "translate(0 -15.321)",
    fill: "#f36fa0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(11.406 25.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M18.83,48.355a2.264,2.264,0,0,1-.772.5,2.557,2.557,0,0,1-.93.166,2.51,2.51,0,0,1-1.008-.2,2.258,2.258,0,0,1-.805-.59,2.781,2.781,0,0,1-.54-.979,4.836,4.836,0,0,1,0-2.718,2.767,2.767,0,0,1,.54-.975,2.3,2.3,0,0,1,.809-.594,2.47,2.47,0,0,1,1-.2,2.57,2.57,0,0,1,.93.166,2.268,2.268,0,0,1,.772.5l-.689.614a1.258,1.258,0,0,0-.461-.348,1.335,1.335,0,0,0-.527-.108,1.5,1.5,0,0,0-.585.116,1.254,1.254,0,0,0-.5.394,2.03,2.03,0,0,0-.344.718,4.236,4.236,0,0,0-.133,1.079,4.29,4.29,0,0,0,.129,1.063,2.081,2.081,0,0,0,.332.718,1.331,1.331,0,0,0,.481.407,1.3,1.3,0,0,0,.569.129,1.458,1.458,0,0,0,.56-.108,1.316,1.316,0,0,0,.477-.348Z",
    transform: "translate(-14.581 -42.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M27.334,47.3a1.579,1.579,0,0,1-.137.644,1.679,1.679,0,0,1-.386.548,1.857,1.857,0,0,1-.614.378,2.29,2.29,0,0,1-.83.141c-.133,0-.27-.007-.411-.021a3.335,3.335,0,0,1-.427-.07,2.238,2.238,0,0,1-.411-.137,1.318,1.318,0,0,1-.336-.212l.174-.714a1.75,1.75,0,0,0,.294.129c.119.041.242.08.369.116a3.724,3.724,0,0,0,.382.087,2.113,2.113,0,0,0,.357.033,1.14,1.14,0,0,0,.776-.237.884.884,0,0,0,.27-.7.672.672,0,0,0-.191-.481,2.067,2.067,0,0,0-.477-.361q-.286-.162-.619-.324a3.748,3.748,0,0,1-.622-.382,1.992,1.992,0,0,1-.481-.519,1.359,1.359,0,0,1-.191-.747,1.668,1.668,0,0,1,.149-.722,1.615,1.615,0,0,1,.4-.535,1.781,1.781,0,0,1,.59-.336,2.151,2.151,0,0,1,.71-.116,4.354,4.354,0,0,1,.772.07,1.7,1.7,0,0,1,.631.228c-.033.072-.072.151-.116.237l-.124.24c-.039.075-.072.137-.1.187a.767.767,0,0,1-.05.083,1,1,0,0,1-.112-.066.859.859,0,0,0-.179-.083,1.273,1.273,0,0,0-.307-.058,2.9,2.9,0,0,0-.49.008.857.857,0,0,0-.316.1,1.093,1.093,0,0,0-.266.195.889.889,0,0,0-.183.262.668.668,0,0,0-.066.278.751.751,0,0,0,.191.535,1.85,1.85,0,0,0,.473.357q.282.154.614.3a3.351,3.351,0,0,1,.619.353,1.782,1.782,0,0,1,.477.519A1.493,1.493,0,0,1,27.334,47.3Z",
    transform: "translate(-18.195 -42.76)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    d: "M32.8,49.075l-1.9-6.151h1.137L33.461,48.2l1.5-5.279h1.129L34.1,49.075Z",
    transform: "translate(-20.994 -42.824)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M18.786,14.429V12H11.5V25.357H31.536V14.429Zm-6.071-1.214h4.857v1.214H12.714Zm0,2.429h4.857v1.214H12.714Zm0,2.429h4.857v1.214H12.714Zm0,2.429h4.857v1.214H12.714Zm4.857,3.643H12.714V22.929h4.857Zm12.75,0H18.786V22.929H30.321Zm0-2.429H18.786V20.5H30.321Zm0-2.429H18.786V18.071H30.321ZM18.786,16.857V15.643H30.321v1.214Z",
    transform: "translate(-1.964 -4.714)",
    fill: "#c8bdb8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvIcon);
export default __webpack_public_path__ + "static/media/csvIcon.5d333d099601e5e862aaf73325a31220.svg";
export { ForwardRef as ReactComponent };